import { JSONContent } from 'api/page-template/types';
import { BaseCustomSectionAttributes, CustomSectionNodeType } from './common';

export enum CustomGroupSectionType {
  CustomHeadingSection = 'CUSTOM_HEADING_SECTION',
  MultiQuestions = 'MULTI_QUESTIONS',
}
export type CustomGroupSectionConfig = {
  description?: string;
};
export type CustomGroupSectionAttributes = BaseCustomSectionAttributes & {
  config: CustomGroupSectionConfig;
  sectionType: CustomGroupSectionType;
};
export type CustomGroupSectionNode = {
  type: CustomSectionNodeType.RlGroupSection;
  attrs: CustomGroupSectionAttributes;
  content: JSONContent[];
};
